// extracted by mini-css-extract-plugin
export var closeIcon = "attachment-pill-module--close-icon--JSxdY";
export var downloadButton = "attachment-pill-module--download-button--42ouE";
export var elements = "attachment-pill-module--elements--RRLiE";
export var elementsWrapper = "attachment-pill-module--elementsWrapper--tzCqk";
export var folderWrapper = "attachment-pill-module--folder-wrapper--hIVcm";
export var pillText = "attachment-pill-module--pill-text--5ljl9";
export var reverseColors = "attachment-pill-module--reverse-colors--M-UQ0";
export var wrapper = "attachment-pill-module--wrapper--vw8xs";